export default __webpack_public_path__ + "static/media/logo8.43b267dd.png";